import React from "react";
import { Button, Grid } from "@mui/material";
import InviteCard from "src/scenes/invite/invite-card";
import PendingInviteCard from "src/scenes/invite/pending-invites-card";
import ReactCardFlip from "react-card-flip";
import { Helmet } from "react-helmet";
import Flex from "../../components/flex";
import useInvitesApi from "./use-invites-api";

const Invite = () => {
    const [isFlipped, setIsFlipped] = React.useState(false);
    const invitesApi = useInvitesApi();

    return (
        <>
            <Helmet>
                <title>Adadot - Invite</title>
            </Helmet>
            <Grid style={{ maxWidth: "600px" }}>
                <Flex style={{ marginBottom: "3rem" }}>
                    <Button onClick={() => setIsFlipped(false)} variant="outlined" color="primary">
                        Invite Users
                    </Button>
                    <Button onClick={() => setIsFlipped(true)} variant="outlined" color="primary">
                        Pending Invites
                    </Button>
                </Flex>
                <ReactCardFlip isFlipped={isFlipped}>
                    <InviteCard invitesApi={invitesApi} />
                    <PendingInviteCard invitesApi={invitesApi} />
                </ReactCardFlip>
            </Grid>
        </>
    );
};

export default Invite;
